import { apiFetch, getApiUrl } from '@/lib/api';

export async function actionGetUserProfile() {
  const API_URL = getApiUrl();
  const response = await apiFetch('/users/profile');
  if (!response.ok) {
    return { error: 'Falha ao carregar o perfil' };
  }
  const data = await response.json();
  const photoUrl = data.photo ? new URL(data.photo, API_URL).toString() : null;
  return { ...data, photo: photoUrl };
}
